<template lang="pug">
  .height-100
    h3.title Gestión de mis permisos
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.nueva-solicitud(v-if="mostrarSolicitud", key="nueva_solicitud")
        nueva-solicitud-permiso(
          @close="mostrarSolicitud = false"
          @successNew="recargarListaSolicitudes"
        )
      .box.lista-solicitud(v-if="mostrarListaSolicitudes", key="lista_solicitud")
        lista-solicitud-permiso(
          ref="listasolicitudes"
          @close="mostrarListaSolicitudes = false"
        )
      .box.lista-solicitud(v-if="mostrarListaMisPermisos", key="lista_mis_permisos")
        lista-mis-permisos(
          @close="mostrarListaMisPermisos = false"
        )

</template>

<script>
// import { apiGet } from '../util/general'
import SolicitudPermisoComponent from './Component_Permisos_Solicitud'
import ListaSolicitudPermisoComponent from './Component_Permisos_Lista_Solicitud'
import ListaMisPermisosComponent from './Component_Permisos_Lista_Mis_Permisos'
export default {
  name: 'vacaciones',
  components: {
    'nueva-solicitud-permiso' : SolicitudPermisoComponent,
    'lista-solicitud-permiso' : ListaSolicitudPermisoComponent,
    'lista-mis-permisos'      : ListaMisPermisosComponent
  },
  data () {
    return {
      mostrarSolicitud: true,
      mostrarListaSolicitudes: true,
      mostrarListaMisPermisos: true,
      empleado: {}
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
    recargarListaSolicitudes () {
      this.mostrarListaSolicitudes = true
      this.$refs.listasolicitudes.fetch()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
  .nueva-solicitud
    position relative
  .lista-solicitud
    position relative
</style>



// WEBPACK FOOTER //
// View_Permisos_Mis_Permisos.vue?257f26bb